module.exports = __webpack_public_path__ + "img/finalDashboard.d81ff82f.png";